module.exports = __webpack_public_path__ + "static/img/pop_up_title_bg.3ace3e7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/popup/pop_up_title_bg.png
// module id = sjCL
// module chunks = 1